import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';

import climate from 'assets/img/dashboard/climate.png';
import usda from 'assets/img/dashboard/usda.png';
import jas from 'assets/img/dashboard/jas.png';
import feed from 'assets/img/dashboard/feed.png';
import ab from 'assets/img/dashboard/ab.png';
import ls from 'assets/img/dashboard/ls.png';
import jn from 'assets/img/dashboard/jn.png';
import efas from 'assets/img/dashboard/efas.png';
import jd from 'assets/img/dashboard/jd.png';
import { getText } from 'function/language';

/**
 * 대시보드 > 메인 대시보드 - 링크
 */
const Link = () => {
  /* view */
  return (
    <Row>
      <Col xxl={3}>
        <Card className="h-100">
          <Card.Header className="bg-100">
            <h5 className="fs--1 text-900 fw-bold mb-0 lh-1">
              {getText('usdaLink')}
            </h5>
          </Card.Header>
          <Card.Body className="py-3">
            <Row xxl={2} className="h-100">
              <Col>
                <a
                  href="https://data.kma.go.kr/data/ogd/selectGtsRltmList.do?pgmNo=658"
                  className="d-flex flex-row align-items-center h-100"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img
                    src={climate}
                    alt={getText('climate')}
                    className="me-2"
                  />
                  <p className="text-primary mb-0 fs--1 lh-sm">
                    {getText('climate')}
                  </p>
                </a>
              </Col>
              <Col>
                <a
                  href="https://www.usda.gov/oce/commodity/wasde"
                  className="d-flex flex-row align-items-center h-100"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img src={usda} alt={getText('usda')} className="me-2" />
                  <p className="text-primary mb-0 fs--1 lh-sm">
                    {getText('usda')}
                  </p>
                </a>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
      <Col xxl={9}>
        <Card className="h-100">
          <Card.Header className="bg-100">
            <h5 className="fs--1 text-900 fw-bold mb-0 lh-1">
              {getText('academicJournal')}
            </h5>
          </Card.Header>
          <Card.Body className="py-2">
            <Row>
              <Col>
                <a
                  href="https://academic.oup.com/jas"
                  className="d-flex flex-row align-items-center h-100"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img src={jas} alt={getText('jas')} className="me-2" />
                  <p className="text-primary mb-0 fs--1 lh-sm">
                    {getText('jas')}
                  </p>
                </a>
              </Col>
              <Col>
                <a
                  href="https://www.sciencedirect.com/journal/animal-feed-science-and-technology"
                  className="d-flex flex-row align-items-center h-100"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img src={feed} alt={getText('feed')} className="me-2" />
                  <p className="text-primary mb-0 fs--1 lh-sm">
                    {getText('feed')}
                  </p>
                </a>
              </Col>
              <Col>
                <a
                  href="https://www.animbiosci.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex flex-row align-items-center h-100"
                >
                  <img src={ab} alt={getText('ab')} className="me-2" />
                  <p className="text-primary mb-0 fs--1 lh-sm">
                    {getText('ab')}
                  </p>
                </a>
              </Col>
              <Col>
                <a
                  href="https://www.journals.elsevier.com/livestock-science"
                  className="d-flex flex-row align-items-center h-100"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img src={ls} alt={getText('ls')} className="me-2" />
                  <p className="text-primary mb-0 fs--1 lh-sm">
                    {getText('ls')}
                  </p>
                </a>
              </Col>
              <Col>
                <a
                  href="https://academic.oup.com/jn"
                  className="d-flex flex-row align-items-center h-100"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img src={jn} alt={getText('jn')} className="me-2" />
                  <p className="text-primary mb-0 fs--1 lh-sm">
                    {getText('jn')}
                  </p>
                </a>
              </Col>
              <Col>
                <a
                  href="https://www.eaap.org/"
                  className="d-flex flex-row align-items-center h-100"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img src={efas} alt={getText('efas')} className="me-2" />
                  <p className="text-primary mb-0 fs--1 lh-sm">
                    {getText('efas')}
                  </p>
                </a>
              </Col>
              <Col>
                <a
                  href="https://www.journalofdairyscience.org"
                  className="d-flex flex-row align-items-center h-100"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img src={jd} alt={getText('jd')} className="me-2" />
                  <p className="text-primary mb-0 fs--1 lh-sm">
                    {getText('jd')}
                  </p>
                </a>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default Link;
